import { createIcon } from '../shared'

const ShareIcon = createIcon(
  ({ color }) => (
    <path
      d="M12 2.58984L17.7 8.28984L16.29 9.70984L13 6.40984V15.9998H11V6.40984L7.7 9.70984L6.29 8.28984L12 2.58984ZM21 14.9998L20.98 18.5098C20.98 19.8898 19.86 20.9998 18.48 20.9998H5.5C4.11 20.9998 3 19.8798 3 18.4998V14.9998H5V18.4998C5 18.7798 5.22 18.9998 5.5 18.9998H18.48C18.76 18.9998 18.98 18.7798 18.98 18.4998L19 14.9998H21Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'TwitterShareIcon',
)

export { ShareIcon }
